<template>
    <div class="container">
        <iframe width="100%" height="100%" v-bind:src="url"></iframe>
    </div>
</template>

<script>
export default {
    props: {
        url: String
    }
}
</script>

<style scoped>
.container {
    overflow: scroll;
    padding: 0px;
}
</style>
